import { render, staticRenderFns } from "./AnswerSemiologies.vue?vue&type=template&id=80063c06&"
import script from "./AnswerSemiologies.vue?vue&type=script&lang=js&"
export * from "./AnswerSemiologies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataIterator,VSelect,VTextField})
